/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Moment } from "moment";
import Tooltip from "PFComponents/tooltip/tooltip";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import CutIcon from "PFIcons/cut.svg";
import React from "react";

import { useBookingBarContext } from "../booking_bar_provider";
import BookingTooltipContent from "../booking_tooltip_content";
import css from "./day_separator.module.scss";

interface DaySeparatorProps {
  date: Moment;
  width: number;
  onClick: () => void;
}

export const DaySeparator = ({ date, width, onClick }: DaySeparatorProps): JSX.Element => {
  const { booking, category } = useBookingBarContext();
  const { formatDate } = useDateFormatter();
  return (
    <Tooltip
      content={
        <BookingTooltipContent
          title={booking?.title}
          categoryName={category?.display_as}
          additionalInfo={<span className={css.date}>{formatDate(date)}</span>}
        />
      }
      placement="top"
      delay={0}
    >
      <div onClick={onClick} className={css.daySeparator} style={{ width }}>
        <div className={css.divider} />
        <div className={css.iconContainer}>
          <CutIcon className={css.cutIcon} width={20} />
        </div>
      </div>
    </Tooltip>
  );
};
